import React, { useState } from 'react';
import './FaleConosco.css';
import axios from 'axios';

import navIcon1 from '../../assets/images/youtube.svg';
import navIcon2 from '../../assets/images/twitter.svg';
import navIcon3 from '../../assets/images/instagram.svg';
import navIcon4 from '../../assets/images/face.svg';
import navIcon5 from '../../assets/images/home.png';
import navIcon6 from '../../assets/images/endereco.png';
import navIcon7 from '../../assets/images/email.png';
import navIcon8 from '../../assets/images/phone.png';

import { Container, Row, Col } from 'react-bootstrap';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const FaleConosco = () => {
  const formInitialDetails = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  };

  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState('Enviar');
  const [status, setStatus] = useState({});
  const apiUrl = process.env.REACT_APP_API_URL || "/api";

  const onFormUpdate = (category, value) => {
    setFormDetails({
      ...formDetails,
      [category]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setButtonText("Enviando...");
    
    try {
      const response = await axios.post(`${apiUrl}/contact`, formDetails, {
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      const result = response.data; // No axios, a resposta vem em response.data
  
      setButtonText("Enviar");
      setFormDetails(formInitialDetails);
      if (result.code === 200) {
        setStatus({ success: true, message: "Mensagem enviada com sucesso!" });
      } else {
        setStatus({ success: false, message: "Algo deu errado, tente novamente mais tarde." });
      }
    } catch (error) {
      console.error("Erro ao enviar:", error);
      setButtonText("Enviar");
      setStatus({ success: false, message: "Erro ao enviar, tente novamente mais tarde." });
    }
  };
  

  return (
    <div>
      <section className="contact" id="FaleConosco">
        <Container>
          <Row className="align-items-center">
            <Col size={12} md={6}>
              <TrackVisibility>
                <div className="contact-details">
                  <h3>O ensino da fé cristã na Península Ibérica</h3>
                  <p>Departamento de História<br />UNESP/FCL - Câmpus de Assis</p>
                  <ul className="contact-short-info">
                    <li>
                      <span><img src={navIcon5} id="icons" alt="home" /> Av. Dom Antonio, 2100 - Parque Universitário</span>
                    </li>
                    <li>
                      <span><img src={navIcon6} id="icons" alt="address" /> Assis - São Paulo - Brasil - CEP 19806-900</span>
                    </li>
                    <li>
                      <span><img src={navIcon8} id="icons" alt="phone" /> Telefone / VoIP: (18) 3302-5861 / 5861</span>
                    </li>
                    <li>
                      <span><img src={navIcon7} id="icons" alt="email" /> E-mail: umahistoriadapeninsula@gmail.com</span>
                    </li>
                  </ul>
                  <div className="social-icon">
                    <a href="https://www.youtube.com/channel/UCOqszOrTMrhmlUvWCKXiT0A"><img src={navIcon1} alt="YouTube" /></a>
                    <a href="https://twitter.com/DaPeninsula"><img src={navIcon2} alt="Twitter" /></a>
                    <a href="https://www.instagram.com/historiadapeninsula_unicamp/"><img src={navIcon3} alt="Instagram" /></a>
                    <a href="https://www.facebook.com/profile.php?id=61558268759636&name=xhp_nt__fb__action__open_user&_rdr"><img src={navIcon4} alt="Facebook" /></a>
                  </div>
                </div>
              </TrackVisibility>
            </Col>
            <Col size={12} md={6}>
              <TrackVisibility>
                {({ isVisible }) => (
                  <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                    <h2>Entrar em contato</h2>
                    <form onSubmit={handleSubmit} className="form-contato">
                      <Row>
                        <Col size={12} sm={6} className="px-1">
                          <input
                            type="text"
                            value={formDetails.firstName}
                            placeholder="Primeiro Nome"
                            onChange={(e) => onFormUpdate('firstName', e.target.value)}
                          />
                        </Col>
                        <Col size={12} sm={6} className="px-1">
                          <input
                            type="text"
                            value={formDetails.lastName}
                            placeholder="Último Nome"
                            onChange={(e) => onFormUpdate('lastName', e.target.value)}
                          />
                        </Col>
                        <Col size={12} sm={6} className="px-1">
                          <input
                            type="email"
                            value={formDetails.email}
                            placeholder="Endereço de Email"
                            onChange={(e) => onFormUpdate('email', e.target.value)}
                          />
                        </Col>
                        <Col size={12} sm={6} className="px-1">
                          <input
                            type="tel"
                            value={formDetails.phone}
                            placeholder="Telefone"
                            onChange={(e) => onFormUpdate('phone', e.target.value)}
                          />
                        </Col>
                        <Col size={12} className="px-1">
                          <textarea
                            rows="6"
                            value={formDetails.message}
                            placeholder="Mensagem"
                            onChange={(e) => onFormUpdate('message', e.target.value)}
                          />
                          <button type="submit"><span>{buttonText}</span></button>
                        </Col>
                        {status.message && (
                          <Col>
                            <p className={status.success === false ? "danger" : "success"}>{status.message}</p>
                          </Col>
                        )}
                      </Row>
                    </form>
                  </div>
                )}
              </TrackVisibility>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};
